'use strict';

/**
 * @classname FooterAccordion
 * @classdesc フッターアコーディオン
 */
export default class FooterAccordion {
	/**
	 * @constructor
	 * @param {jQuery} $e - .anchor--footer-accordion
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._$list = $e.closest('.block--footer-accordion').find('.list');
		$e.on('click', () => this.FooterAccordionToggle());
	};


	/**
	 * フッターアコーディオン開閉
	 *
	 * @memberof FooterAccordion
	 * @return undefined
	 */
	FooterAccordionToggle() {
		console.log(`${this.constructor.name}.FooterAccordionToggle`);
		if(this._$e.hasClass('open')){
			this._$e.removeClass('open').addClass('close');
			this._$list.slideUp();
		}else{
			this._$e.removeClass('close').addClass('open');
			this._$list.slideDown();
		}
	};


	/**
	 * 検索エリアを閉じる
	 *
	 * @memberof FooterAccordion
	 * @return undefined
	 */
	FooterAccordionClose() {
		console.log(`${this.constructor.name}.FooterAccordionClose`);
		this._$searchWrap.removeClass('down').addClass('up');
	};
};
